import React, { useEffect } from 'react'
import i18n from 'live/services/i18n'
import PackagesList from './PackagesList'

const Packages: React.VFC = () => {
    useEffect(() => {
        document.title = `Live: ${i18n('Packages')}`
    }, [])

    return <PackagesList />
}

export default Packages
